import React, {useEffect, useState} from 'react'
import {Grid, Input, Segment, Icon, Form, Radio, Header, Table, Checkbox, Dropdown, Button, Dimmer, Loader} from "semantic-ui-react";
import Axios from "axios";
import MaskedInput from "react-input-mask";
import {DateInput} from "semantic-ui-calendar-react";
import Constants from "../../../config/constants";
import moment from "moment";
import objDefault from "../../../models/vteModel";
import {useHistory} from "react-router-dom";


const safeSplit = (val) => typeof val === 'string' ? val.split('&') : [];

const Vte = () => {
    const history = useHistory()
    const [input, setInput] = useState({
        ...objDefault
    });
    const [loading, setLoading] = useState(false);
    const [day7, setDay7] = useState({day: 0})
    const [day14, setDay14] = useState({day: 0})
    const [ids, setIds] = useState({admission_id: 0, patient_id: 0, state: 0})
    const [grpPoint, setGrpPoint] = useState(0)
    const [patient, setPatient] = useState({});
    const options7 = [
        {key: 1, text: '1 วัน', value: 1},
        {key: 2, text: '2 วัน', value: 2},
        {key: 3, text: '3 วัน', value: 3},
        {key: 4, text: '4 วัน', value: 4},
        {key: 5, text: '5 วัน', value: 5},
        {key: 6, text: '6 วัน', value: 6},
        {key: 7, text: '7 วัน', value: 7},
    ]
    const options14 = [
        {key: 1, text: '1 วัน', value: 1},
        {key: 2, text: '2 วัน', value: 2},
        {key: 3, text: '3 วัน', value: 3},
        {key: 4, text: '4 วัน', value: 4},
        {key: 5, text: '5 วัน', value: 5},
        {key: 6, text: '6 วัน', value: 6},
        {key: 7, text: '7 วัน', value: 7},
        {key: 8, text: '8 วัน', value: 8},
        {key: 9, text: '9 วัน', value: 9},
        {key: 10, text: '10 วัน', value: 10},
        {key: 11, text: '11 วัน', value: 11},
        {key: 12, text: '12 วัน', value: 12},
        {key: 13, text: '13 วัน', value: 13},
        {key: 14, text: '14 วัน', value: 14},
    ]
    const handleInputChangeScore = (e) => {
        const {name, value, checked} = e.target;
        if (checked === true) {
            setInput((prevInput) => ({
                ...prevInput,
                [name]: value,
            }))
        } else {
            setInput((prevInput) => ({
                ...prevInput,
                [name]: 0,
            }))
        }
    }
    const handleInputChange = (e) => {
        const {name, value, checked} = e.target;
        if (checked === true) {
            setInput((prevInput) => ({
                ...prevInput,
                [name]: value,
            }))

        } else {
            setInput((prevInput) => ({
                ...prevInput,
                [name]: 'N',
            }))

        }

        if (name === 'vte_grs_hospitalize' && value === 'high') {
            setInput((prevInput) => ({
                ...prevInput,
                vte_grs_confinedtobed: '',
                vte_grs_intoxication: '',
                vte_grs_restraints: ''
            }))
        }
        if (name === 'need_pharmacological' && value === 'N') {
            setInput((prevInput) => ({
                ...prevInput,
                vte_grs_no_indication: '',
                vte_grs_enoxaparin: '',
                vte_grs_heparin: '',
                vte_grs_presented: '',
                vte_grs_sequential: ''
            }))
        }

    };
    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };
    const setPoint = () => {
        let point = cleanPoint(input.vte_bmi) + cleanPoint(input.vte_malignancy) + cleanPoint(input.vte_abnormal_coagulation) + cleanPoint(input.vte_history_of_thromboembolism) + cleanPoint(input.vte_ais_head) + cleanPoint(input.vte_ais_chest) + cleanPoint(input.vte_ais_abdomen) + cleanPoint(input.vte_gcs_score) + cleanPoint(input.vte_complex_lower) + cleanPoint(input.vte_pelvic_fracture) + cleanPoint(input.vte_femoral_central) + cleanPoint(input.vte_transfusion) + cleanPoint(input.vte_surgical_procedure) + cleanPoint(input.vte_repair_ligation) + cleanPoint(input.vte_age40year) + cleanPoint(input.vte_age60year) + cleanPoint(input.vte_age75year)
        setGrpPoint(point)
    }
    const cleanPoint = (point) => {
        let p = 0
        p = point && isNaN(point) === false ? parseInt(point) : 0
        return p
    }

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            try {
                const search = window.location.search;
                const params = new URLSearchParams(search);
                const admission_id = params.get('admission_id');
                const patient_id = params.get('patient_id');
                const vte_admission_date = params.get('admission_date');
                const state = params.get('state');
                
                setInput((prevInput) => ({
                    ...prevInput,
                    vte_patient_id: patient_id,
                    vte_admission_id: admission_id,
                    vte_admission_date: vte_admission_date ? moment(vte_admission_date).format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY"),
                }));

                setIds((prevInput) => ({
                    ...prevInput,
                    admission_id: admission_id,
                    patient_id: patient_id,
                    state: state
                }));

                await getUserById(patient_id);

                if (state == '1') {
                    await getVte(admission_id);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        init();
    }, []);

    const getVte = async (admission_id) => {
        try {
            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/vte?id=' + admission_id, {
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
            let res = response.data.data[0] || {};
            setInput((prevInput) => ({
                ...prevInput,
                vte_admission_date: res.vte_admission_date ? moment(res.vte_admission_date).format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY"),
                vte_assessment_date: res.vte_assessment_date ? moment(res.vte_assessment_date).format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY"),
                vte_bmi: res.vte_bmi,
                vte_malignancy: res.vte_malignancy,
                vte_abnormal_coagulation: res.vte_abnormal_coagulation,
                vte_history_of_thromboembolism: res.vte_history_of_thromboembolism,
                vte_ais_head: res.vte_ais_head,
                vte_ais_chest: res.vte_ais_chest,
                vte_ais_abdomen: res.vte_ais_abdomen,
                vte_gcs_score: res.vte_gcs_score,
                vte_complex_lower: res.vte_complex_lower,
                vte_pelvic_fracture: res.vte_pelvic_fracture,
                vte_femoral_central: res.vte_femoral_central,
                vte_transfusion: res.vte_transfusion,
                vte_surgical_procedure: res.vte_surgical_procedure,
                vte_repair_ligation: res.vte_repair_ligation,
                vte_age40year: res.vte_age40year,
                vte_age60year: res.vte_age60year,
                vte_age75year: res.vte_age75year,
                vte_grs_bleeding: res.vte_grs_bleeding,
                vte_hemodynamic_instability: safeSplit(res.vte_hemodynamic_instability),
                vte_grs_traumatic: res.vte_grs_traumatic,
                vte_grs_spinal_cord: res.vte_grs_spinal_cord,
                vte_grs_risk: res.vte_grs_risk,
                vte_grs_hospitalized: res.vte_grs_hospitalized,
                vte_grs_confinedtobed: res.vte_grs_confinedtobed,
                vte_grs_intoxication: res.vte_grs_intoxication,
                vte_grs_restraints: res.vte_grs_restraints,
                vte_grs_no_indication: res.vte_grs_no_indication,
                vte_grs_enoxaparin: res.vte_grs_enoxaparin,
                vte_grs_heparin: res.vte_grs_heparin,
                vte_grs_presented: res.vte_grs_presented,
                vte_grs_sequential: res.vte_grs_sequential,
                vte_grs_pharmacological_date: res.vte_grs_pharmacological_date,
                vte_grs_pharmacological: res.vte_grs_pharmacological,
                vte_summary_regimen: res.vte_summary_regimen,
                vte_summary_regimen_other: res.vte_summary_regimen_other,
                vte_complication_of_anticoagulant: res.vte_complication_of_anticoagulant,
                vte_complication_of_anticoagulant_remark: res.vte_complication_of_anticoagulant_remark,
                vte_scd: res.vte_scd,
                vte_scd_date: res.vte_scd_date,
                vte_active_bleeding: safeSplit(res.vte_active_bleeding),
                vte_hemoglobin_drop: safeSplit(res.vte_hemoglobin_drop),
                vte_ongoing_blood_transfusion: safeSplit(res.vte_ongoing_blood_transfusion),
                vte_pt: safeSplit(res.vte_pt),
                vte_platelet_count: safeSplit(res.vte_platelet_count),
                vte_grade: safeSplit(res.vte_grade),
                vte_traumatic_brain_Injury: res.vte_traumatic_brain_Injury,
                vte_intracerebral_hemorrhage: res.vte_intracerebral_hemorrhage,
                vte_ICH: res.vte_ICH,
                vte_progrssion: safeSplit(res.vte_progrssion),
                vte_presented: safeSplit(res.vte_presented),
                vte_spinal_injury: res.vte_spinal_injury,
                vte_no_operation: res.vte_no_operation,
                vte_plan_operation_with24: res.vte_plan_operation_with24,
                vte_plan_operation_over24: res.vte_plan_operation_over24,
                vte_duplex_us: res.vte_duplex_us,
                vte_duplex_us_remark: res.vte_duplex_us_remark,
                vte_dvt: res.vte_dvt,
                vte_presented_dvt: res.vte_presented_dvt,
                vte_presented_dvt_remark: res.vte_presented_dvt_remark,
                vte_throbbing_cramping : safeSplit(res.vte_throbbing_cramping),
                vte_swell : safeSplit(res.vte_swell),
                vte_warm_skin : safeSplit(res.vte_warm_skin),
                vte_reddarkened :  safeSplit(res.vte_reddarkened),
                vte_dyspnea :  safeSplit(res.vte_dyspnea),
                vte_chest_pain  : safeSplit(res.vte_chest_pain),
                vte_hemoptysis : safeSplit(res.vte_hemoptysis),
                vte_syncope  : safeSplit(res.vte_syncope),
                vte_tachycardia  : safeSplit(res.vte_tachycardia),
                vte_tachypnea : safeSplit(res.vte_tachypnea),
                vte_decrease : safeSplit(res.vte_decrease),
                vte_jugular  : safeSplit(res.vte_jugular),
                vte_decreaseO : safeSplit(res.vte_decreaseO),
                vte_sqt_ecg :  safeSplit(res.vte_sqt_ecg),
                vte_summary_need: res.vte_summary_need,
                vte_summary_need_date: res.vte_summary_need_date,
                vte_summary_regimen_enoxaparin_heparin: res.vte_summary_regimen_enoxaparin_heparin,
                vte_summary_regiment_remark: res.vte_summary_regiment_remark,
                vte_summary_complication: res.vte_summary_complication,
                vte_summary_complication_remark: res.vte_summary_complication_remark,
                vte_summary_sequential: res.vte_summary_sequential,
                vte_summary_sequential_date: res.vte_summary_sequential_date,
                vte_sleep_part2: res.vte_sleep_part2,
                vte_sleep_part3: res.vte_sleep_part3,
            }));
            setDay7({day: res.vte_sleep_part2 || 0});
            setDay14({day: res.vte_sleep_part3 || 0});

            let point = cleanPoint(res.vte_bmi) + cleanPoint(res.vte_malignancy) + cleanPoint(res.vte_abnormal_coagulation) + cleanPoint(res.vte_history_of_thromboembolism) + cleanPoint(res.vte_ais_head) + cleanPoint(res.vte_ais_chest) + cleanPoint(res.vte_ais_abdomen) + cleanPoint(res.vte_gcs_score) + cleanPoint(res.vte_complex_lower) + cleanPoint(res.vte_pelvic_fracture) + cleanPoint(res.vte_femoral_central) + cleanPoint(res.vte_transfusion) + cleanPoint(res.vte_surgical_procedure) + cleanPoint(res.vte_repair_ligation) + cleanPoint(res.vte_age40year) + cleanPoint(res.vte_age60year) + cleanPoint(res.vte_age75year);
            setGrpPoint(point);
        } catch (e) {
            console.log(e);
        }
    }

    const getUserById = async (user) => {
        try {
            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/patient?id=' + user, {
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
            response = response.data.data[0]
            setPatient((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                hn: response.hn ? response.hn : '-',
                blood_group: response.blood_group ? response.blood_group : '-',
                rh: response.rh ? response.rh : '-',
            }))

        } catch (e) {
            console.log(e);
        }
    }

    const saveVte = async () => {
        setLoading(true);
        try {
            let response = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/vte',
                {
                    day7: day7.day,
                    day14: day14.day,
                    data: input
                },
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    },
                }
            );

            alert('บันทึกสำเร็จ')
           // history.push('/home')
        } catch (e) {
            alert('เกิดข้อผิดพลาด')
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>

                <div style={{flex: 1, position: 'relative'}}>
                    <Dimmer active={loading} inverted>
                        <Loader size='large'>กำลังโหลดข้อมูล...</Loader>
                    </Dimmer>

                    <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment color='teal' raised>
                                    <Header as='h3' dividing>
                                        {ids.state == '1' ?
                                            <>
                                                <Button color='red'
                                                        onClick={() => window.open('/vte/pdf?admission_id=' + ids.admission_id + '&patient_id=' + ids.patient_id, '_blank')}>
                                                    <Icon name={'file pdf'}></Icon> VTE
                                                </Button>
                                            </> : <></>
                                        }


                                        <Button color='instagram'
                                                onClick={() => window.open('https://snr-file.fra1.digitaloceanspaces.com/vte/VTE_page2.pdf', '_blank')}>
                                            <Icon name={'file pdf'}></Icon> VTE blank page
                                        </Button>

                                    </Header>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={15}>
                                <Segment color='teal' raised>
                                    <Header as='h3' block>
                                        แบบประเมินความเสี่ยงการเกิดหลอดเลือดดําอุดตันในผู้บาดเจ็บจากอุบัติเหตุ (
                                        HN {patient.hn} ชื่อ {patient.name} {patient.surname} หมู่เลือด {patient.blood_group} RH {patient.rh} )
                                    </Header>
                                    <Header as='h3' dividing color='blue'>
                                        Part 1 : Admission Evaluation
                                    </Header>
                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Input

                                                fluid label='วันที่ Admission'
                                                name='vte_admission_date'
                                                value={input.vte_admission_date}
                                                placeholder='วันที่ Admission'
                                                disabled={true}
                                            />
                                            <DateInput
                                                name="vte_assessment_date"
                                                placeholder="Date"
                                                value={input.vte_assessment_date}
                                                label='วันที่ Assessment '
                                                iconPosition="right"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                                required={true}
                                            />
                                        </Form.Group>
                                    </Form>

                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={'8'}>
                                <Header as='h3' block>Greenfield Risk Assessment Profile</Header>
                                <Form>
                                    <Table celled>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>#</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '80%'}}>Underlying
                                                    conditions</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '10%'}}>Point</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell>1</Table.Cell>
                                                <Table.Cell>Obesity (BMI > 30 kg/m2)</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_bmi'
                                                        checked={input.vte_bmi ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>2</Table.Cell>
                                                <Table.Cell>Malignancy</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_malignancy'
                                                        checked={input.vte_malignancy ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>3</Table.Cell>
                                                <Table.Cell>Abnormal coagulation (PT, PTT, INR)</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_abnormal_coagulation'
                                                        checked={input.vte_abnormal_coagulation ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>4</Table.Cell>
                                                <Table.Cell>History of thromboembolism</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_history_of_thromboembolism'
                                                        checked={input.vte_history_of_thromboembolism ? true : false}
                                                        value='3'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Form>
                            </Grid.Column>
                            <Grid.Column width={'7'}>
                                <Form>
                                    <Table celled>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell style={{width: '10%'}}>#</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '80%'}}>Injury-related
                                                    factors</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '10%'}}>Point</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell>1</Table.Cell>
                                                <Table.Cell>AIS head > 2</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_ais_head'
                                                        checked={input.vte_ais_head ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>2</Table.Cell>
                                                <Table.Cell>AIS chest > 2</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_ais_chest'
                                                        checked={input.vte_ais_chest ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>3</Table.Cell>
                                                <Table.Cell>AIS abdomen > 2</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_ais_abdomen'
                                                        checked={input.vte_ais_abdomen ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>4</Table.Cell>
                                                <Table.Cell>{`GCS score < 8 for > 4 hr`}</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_gcs_score'
                                                        checked={input.vte_gcs_score ? true : false}
                                                        value='3'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>5</Table.Cell>
                                                <Table.Cell>Complex lower extremity fracture (severe soft tissue damage,
                                                    articular involvement, neurovascular injuries)</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_complex_lower'
                                                        checked={input.vte_complex_lower ? true : false}
                                                        value='3'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>6</Table.Cell>
                                                <Table.Cell>Pelvic fracture</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_pelvic_fracture'
                                                        checked={input.vte_pelvic_fracture ? true : false}
                                                        value='4'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={'8'}>
                                <Form>
                                    <Table celled>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>#</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '80%'}}>Iatrogenic
                                                    factors</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '10%'}}>Point</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell>1</Table.Cell>
                                                <Table.Cell>Femoral central venous catheter > 24hr</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_femoral_central'
                                                        checked={input.vte_femoral_central ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>2</Table.Cell>
                                                <Table.Cell>Transfusion ≥ 4 units in 24 hr</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_transfusion'
                                                        checked={input.vte_transfusion ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>3</Table.Cell>
                                                <Table.Cell>Surgical procedure >2hr</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_surgical_procedure'
                                                        checked={input.vte_surgical_procedure ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>4</Table.Cell>
                                                <Table.Cell>Repair or ligation of major vascular injury</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_repair_ligation'
                                                        checked={input.vte_repair_ligation ? true : false}
                                                        value='3'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Form>
                            </Grid.Column>
                            <Grid.Column width={'7'}>
                                <Form>
                                    <Table celled>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>#</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '70%'}}>Age</Table.HeaderCell>
                                                <Table.HeaderCell style={{width: '20%'}}>Point</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell>1</Table.Cell>
                                                <Table.Cell>40 – 59 years</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_age40year'
                                                        checked={input.vte_age40year ? true : false}
                                                        value='2'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>2</Table.Cell>
                                                <Table.Cell>60 – 74 years</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_age60year'
                                                        checked={input.vte_age60year ? true : false}
                                                        value='3'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>3</Table.Cell>
                                                <Table.Cell>≥75 years</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox
                                                        checkbox
                                                        name='vte_age75year'
                                                        checked={input.vte_age75year ? true : false}
                                                        value='4'
                                                        onChange={(e, {
                                                            name,
                                                            value,
                                                            checked
                                                        }) => handleInputChangeScore({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row active>
                                                <Table.Cell></Table.Cell>
                                                <Table.Cell>คะแนนรวม
                                                    <Button size='mini' icon color='info'
                                                            onClick={() => setPoint()}
                                                            key={grpPoint}><Icon
                                                        name="sync"></Icon></Button>
                                                </Table.Cell>
                                                <Table.Cell>{grpPoint} <Button size='mini' icon color='info'
                                                                               onClick={() => setPoint()}
                                                                               key={grpPoint}><Icon
                                                    name="sync"></Icon></Button>
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={15}>

                                <Segment color='teal' raised>
                                    <Form>
                                        <Header as='h3' dividing color='blue'>
                                            **Indication for delayed pharmacological prophylaxis
                                        </Header>
                                        <Form.Field>
                                            <Checkbox
                                                checkbox
                                                label='Bleeding risk : active bleeding, coagulopathy, hemodynamic instability, solid organ injury, included pre-/or post-operation'
                                                name='vte_grs_bleeding'
                                                checked={input.vte_grs_bleeding === 'Y' ? true : false}
                                                value='Y'
                                                onChange={(e, {name, value, checked}) => handleInputChange({
                                                    target: {
                                                        name,
                                                        value,
                                                        checked
                                                    }
                                                })}

                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Checkbox
                                                checkbox
                                                label='Traumatic brain injury'
                                                name='vte_grs_traumatic'
                                                value='Y'
                                                checked={input.vte_grs_traumatic === 'Y' ? true : false}
                                                onChange={(e, {name, value, checked}) => handleInputChange({
                                                    target: {
                                                        name,
                                                        value,
                                                        checked
                                                    }
                                                })}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Checkbox
                                                checkbox
                                                checked={input.vte_grs_spinal_cord === 'Y' ? true : false}
                                                label='Spinal cord injury'
                                                name='vte_grs_spinal_cord'
                                                value='Y'
                                                onChange={(e, {name, value, checked}) => handleInputChange({
                                                    target: {
                                                        name,
                                                        value,
                                                        checked
                                                    }
                                                })}

                                            />
                                        </Form.Field>
                                    </Form>
                                    <Header as='h3' block>
                                        Greenfield RAP score
                                    </Header>

                                    <Form>

                                        <Radio label='Low risk (<10)'
                                               checked={input.vte_grs_risk === 'low' ? true : false}
                                               name={'vte_grs_risk'}
                                               onChange={(e, {name, value, checked}) => handleInputChange({
                                                   target: {
                                                       name,
                                                       value,
                                                       checked
                                                   }
                                               })} value='low'/>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <Radio label='High risk (≥ 10)'
                                               checked={input.vte_grs_risk === 'high' ? true : false}
                                               name={'vte_grs_risk'}
                                               onChange={(e, {name, value, checked}) => handleInputChange({
                                                   target: {
                                                       name,
                                                       value,
                                                       checked
                                                   }
                                               })} value='high'/>

                                    </Form>
                                    {input.vte_grs_risk === 'low' ? <>
                                        <Header as='h3' dividing color='blue'>
                                            Low risk condition
                                        </Header>
                                        <Form>

                                            <Radio label='Hospitalized <24hr' name={'vte_grs_hospitalize'}
                                                   value={'low'}
                                                   checked={input.vte_grs_hospitalize === 'low' ? true : false}
                                                   onChange={(e, {name, value, checked}) => handleInputChange({
                                                       target: {
                                                           name,
                                                           value,
                                                           checked
                                                       }
                                                   })}
                                            />
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Radio label='Hospitalized ≥24hr' name={'vte_grs_hospitalize'}
                                                   value={'high'}
                                                   checked={input.vte_grs_hospitalize === 'high' ? true : false}
                                                   onChange={(e, {name, value, checked}) => handleInputChange({
                                                       target: {
                                                           name,
                                                           value,
                                                           checked
                                                       }
                                                   })}
                                            />

                                        </Form>
                                    </> : <></>}
                                    {input.vte_grs_hospitalize === 'high' && input.vte_grs_risk === 'low' ? <>
                                        <Header as='h3' dividing color='blue'>
                                            Hospitalized ≥24hr
                                        </Header>
                                        <Form>
                                            <Checkbox
                                                checkbox
                                                label='Confinedtobed'
                                                name='vte_grs_confinedtobed'
                                                checked={input.vte_grs_confinedtobed === 'Y' ? true : false}
                                                value='Y'
                                                onChange={(e, {name, value, checked}) => handleInputChange({
                                                    target: {
                                                        name,
                                                        value,
                                                        checked
                                                    }
                                                })}
                                            />
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Checkbox
                                                checkbox
                                                label='Intoxication'
                                                name='vte_grs_intoxication'
                                                checked={input.vte_grs_intoxication === 'Y' ? true : false}
                                                value='Y'
                                                onChange={(e, {name, value, checked}) => handleInputChange({
                                                    target: {
                                                        name,
                                                        value,
                                                        checked
                                                    }
                                                })}
                                            />
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Checkbox
                                                checkbox
                                                label='Restraints , or etc ...'
                                                name='vte_grs_restraints'
                                                checked={input.vte_grs_restraints === 'Y' ? true : false}
                                                value='Y'
                                                onChange={(e, {name, value, checked}) => handleInputChange({
                                                    target: {
                                                        name,
                                                        value,
                                                        checked
                                                    }
                                                })}
                                            />
                                        </Form>
                                    </> : <></>}
                                    {input.vte_grs_risk !== '' ? <>
                                        <Header as='h3'>
                                            <Form>

                                                <Radio label='No need pharmacological prophylaxis*'
                                                       value={'N'} name={'vte_grs_pharmacological'}
                                                       checked={input.vte_grs_pharmacological === 'N' ? true : false}
                                                       onChange={(e, {name, value, checked}) => handleInputChange({
                                                           target: {
                                                               name,
                                                               value,
                                                               checked
                                                           }
                                                       })}
                                                />
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <Radio label='Need pharmacological prophylaxis'
                                                       value={'Y'} name={'vte_grs_pharmacological'}
                                                       checked={input.vte_grs_pharmacological === 'Y' ? true : false}
                                                       onChange={(e, {name, value, checked}) => handleInputChange({
                                                           target: {
                                                               name,
                                                               value,
                                                               checked
                                                           }
                                                       })}
                                                />

                                            </Form>
                                        </Header>
                                        {input.vte_grs_pharmacological === 'Y' ?
                                            <>
                                                <Grid style={{marginLeft: "2em"}}>
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <Checkbox
                                                                checkbox
                                                                label='**No Indication for delayed pharmacological prophylaxis'
                                                                name='vte_grs_no_indication'
                                                                checked={input.vte_grs_no_indication === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            /><br/>
                                                            <Checkbox
                                                                checkbox
                                                                label='Enoxaparin 40 mg sc OD/ Bemiparin 3500 IU sc OD'
                                                                name='vte_grs_enoxaparin'
                                                                checked={input.vte_grs_enoxaparin === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            /><br/>
                                                            <Checkbox
                                                                checkbox
                                                                label='Heparin 5,000 unit sc q 8 hr (ESRD or GFR < 30)'
                                                                name='vte_grs_heparin'
                                                                checked={input.vte_grs_heparin === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />

                                                        </Grid.Column>
                                                        <Grid.Column width={8}>

                                                            <Checkbox
                                                                checkbox
                                                                label='Presented indication for delayed pharmacological prophylaxis**'
                                                                name='vte_grs_presented'
                                                                checked={input.vte_grs_presented === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                            <Checkbox
                                                                checkbox
                                                                label='Sequential Compression Device (SCD) and Delay Pharmacological Prophylaxis (Part 2)'
                                                                name='vte_grs_sequential'
                                                                checked={input.vte_grs_sequential === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />

                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </>
                                            : <></>}
                                    </> : <></>}


                                    <Header as='h2' dividing color='black'>
                                        Summary
                                    </Header>
                                    <Table celled>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell>1</Table.Cell>
                                                <Table.Cell>Pharmacological prophylaxis</Table.Cell>
                                                <Table.Cell>
                                                    <Radio
                                                        checked={input.vte_summary_need === 'Y' ? true : false}
                                                        label='No need'
                                                        name='vte_summary_need'
                                                        value='Y'
                                                        onChange={(e, {name, value, checked}) => handleInputChange({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />

                                                </Table.Cell>
                                                <Table.Cell><Radio
                                                    checked={input.vte_summary_need === 'N' ? true : false}
                                                    label='Need'
                                                    name='vte_summary_need'

                                                    value='N'
                                                    onChange={(e, {name, value, checked}) => handleInputChange({
                                                        target: {
                                                            name,
                                                            value,
                                                            checked
                                                        }
                                                    })}
                                                /></Table.Cell>
                                                <Table.Cell>
                                                    วันที่เริ่ม&nbsp;&nbsp;&nbsp;&nbsp; <Input type={'text'}
                                                                                               style={{width: '300px'}}
                                                                                               name='vte_summary_need_date'
                                                                                               value={input.vte_summary_need_date}
                                                                                               onChange={(e) => handleValueChange(e)}
                                                />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>2</Table.Cell>
                                                <Table.Cell>Regimen</Table.Cell>
                                                <Table.Cell>
                                                    <Radio
                                                        checked={input.vte_summary_regimen_enoxaparin_heparin === 'Y' ? true : false}
                                                        label='Enoxaparin'
                                                        name='vte_summary_regimen_enoxaparin_heparin'
                                                        value='Y'
                                                        onChange={(e, {name, value, checked}) => handleInputChange({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />


                                                </Table.Cell>
                                                <Table.Cell><Radio
                                                    checked={input.vte_summary_regimen_enoxaparin_heparin === 'N' ? true : false}
                                                    label='Heparin'
                                                    name='vte_summary_regimen_enoxaparin_heparin'
                                                    value='N'
                                                    onChange={(e, {name, value, checked}) => handleInputChange({
                                                        target: {
                                                            name,
                                                            value,
                                                            checked
                                                        }
                                                    })}
                                                /></Table.Cell>
                                                <Table.Cell>อื่นๆ ระบุ&nbsp;&nbsp;&nbsp;&nbsp; <Input type={'text'}
                                                                                                      style={{width: '300px'}}
                                                                                                      name='vte_summary_regiment_remark'
                                                                                                      value={input.vte_summary_regiment_remark}
                                                                                                      onChange={(e) => handleValueChange(e)}
                                                /></Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>3</Table.Cell>
                                                <Table.Cell>Complication of anticoagulant</Table.Cell>
                                                <Table.Cell>
                                                    <Radio
                                                        checked={input.vte_summary_complication === 'N' ? true : false}
                                                        label='No'
                                                        name='vte_summary_complication'
                                                        value='N'
                                                        onChange={(e, {name, value, checked}) => handleInputChange({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell><Radio
                                                    checked={input.vte_summary_complication === 'Y' ? true : false}
                                                    label='Yes'
                                                    name='vte_summary_complication'
                                                    value='Y'
                                                    onChange={(e, {name, value, checked}) => handleInputChange({
                                                        target: {
                                                            name,
                                                            value,
                                                            checked
                                                        }
                                                    })}
                                                /></Table.Cell>
                                                <Table.Cell>ระบุ &nbsp;&nbsp;&nbsp;&nbsp; <Input type={'text'}
                                                                                                 style={{width: '350px'}}
                                                                                                 name='vte_summary_complication_remark'
                                                                                                 value={input.vte_summary_complication_remark}
                                                                                                 onChange={(e) => handleValueChange(e)}/></Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>4</Table.Cell>
                                                <Table.Cell>Sequential Compressive Device</Table.Cell>
                                                <Table.Cell>
                                                    <Radio
                                                        checked={input.vte_summary_sequential === 'N' ? true : false}
                                                        label='No SCD'
                                                        name='vte_summary_sequential'
                                                        value='N'
                                                        onChange={(e, {name, value, checked}) => handleInputChange({
                                                            target: {
                                                                name,
                                                                value,
                                                                checked
                                                            }
                                                        })}
                                                    /></Table.Cell>
                                                <Table.Cell><Radio
                                                    checked={input.vte_summary_sequential === 'Y' ? true : false}
                                                    label='Yes , on SCD'
                                                    name='vte_summary_sequential'
                                                    value='Y'
                                                    onChange={(e, {name, value, checked}) => handleInputChange({
                                                        target: {
                                                            name,
                                                            value,
                                                            checked
                                                        }
                                                    })}
                                                /></Table.Cell>
                                                <Table.Cell>วันที่เริ่มใส่ SCD
                                                    &nbsp;&nbsp;&nbsp;&nbsp; <Input type={'text'}
                                                                                    style={{width: '350px'}}
                                                                                    name='vte_summary_sequential_date'
                                                                                    value={input.vte_summary_sequential_date}
                                                                                    onChange={(e) => handleValueChange(e)}/>
                                                </Table.Cell>
                                            </Table.Row>

                                        </Table.Body>
                                    </Table>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={15}>
                                <Segment color='teal' raised>
                                    <Header as='h3' dividing color='blue'>
                                        Part 2 : Delay Pharmacological VTE Prophylaxis for High Risk Patient
                                        (หากไม่มีข้ามไป Part3)
                                    </Header>
                                    <Header as='h4' color='black'>
                                        จำนวนวันนอน &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;<Dropdown placeholder='days'
                                                                                                   search selection
                                                                                                   name={'vte_sleep_part2'}
                                                                                                   value={input.vte_sleep_part2}
                                                                                                   seleted={'6'}
                                                                                                   options={options7}
                                                                                                   onChange={(e, {value}) => setDay7({day: value})}/>
                                    </Header>
                                    <Form>
                                        <Table celled>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell style={{width: '5%'}}>#</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '25%'}}>Risk of bleeding</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D1</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D2</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D3</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D4</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D5</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D6</Table.HeaderCell>
                                                    <Table.HeaderCell style={{width: '5%'}}>D7</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>

                                            <Table.Body>
                                                <Table.Row>
                                                    <Table.Cell>1</Table.Cell>
                                                    <Table.Cell>Active bleeding</Table.Cell>
                                                    {/*<Checkbox*/}
                                                    {/*    checkbox*/}
                                                    {/*    name='vte_ais_head'*/}
                                                    {/*    checked={input.vte_ais_head ? true : false}*/}
                                                    {/*    value='2'*/}
                                                    {/*    onChange={(e, {*/}
                                                    {/*        name,*/}
                                                    {/*        value,*/}
                                                    {/*        checked*/}
                                                    {/*    }) => handleInputChangeScore({*/}
                                                    {/*        target: {*/}
                                                    {/*            name,*/}
                                                    {/*            value,*/}
                                                    {/*            checked*/}
                                                    {/*        }*/}
                                                    {/*    })}*/}
                                                    {/*/>*/}

                                                    {ids.state == '0' ? <>
                                                            {[...Array(day7.day)].map((x, i) =>
                                                                <Table.Cell>
                                                                    <Checkbox
                                                                        checkbox
                                                                        name={'vte_active_bleeding' + i}
                                                                        value='Y'
                                                                        onClick={(e, {
                                                                            name,
                                                                            value,
                                                                            checked
                                                                        }) => handleInputChange({
                                                                            target: {
                                                                                name,
                                                                                value,
                                                                                checked
                                                                            }
                                                                        })}
                                                                    />
                                                                </Table.Cell>
                                                            )}
                                                        </> :
                                                        <>
                                                            {[...Array(day7.day)].map((x, i) =>
                                                                <Table.Cell>
                                                                    <Checkbox
                                                                        checkbox
                                                                        name={'vte_active_bleeding' + i}
                                                                        defaultChecked={input.vte_active_bleeding[i] === 'Y' ? true : false}
                                                                        value='Y'
                                                                        onClick={(e, {
                                                                            name,
                                                                            value,
                                                                            checked
                                                                        }) => handleInputChange({
                                                                            target: {
                                                                                name,
                                                                                value,
                                                                                checked
                                                                            }
                                                                        })}
                                                                    />
                                                                </Table.Cell>
                                                            )}
                                                        </>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>2</Table.Cell>
                                                    <Table.Cell>Hemodynamic instability</Table.Cell>
                                                    {ids.state == '0' ? <>
                                                            {[...Array(day7.day)].map((x, i) =>
                                                                <Table.Cell>
                                                                    <Checkbox
                                                                        checkbox
                                                                        name={'vte_hemodynamic_instability' + i}
                                                                        value='Y'
                                                                        onChange={(e, {
                                                                            name,
                                                                            value,
                                                                            checked
                                                                        }) => handleInputChange({
                                                                            target: {
                                                                                name,
                                                                                value,
                                                                                checked
                                                                            }
                                                                        })}
                                                                    />
                                                                </Table.Cell>
                                                            )}
                                                        </> :
                                                        <>
                                                            {[...Array(day7.day)].map((x, i) =>
                                                                <Table.Cell>
                                                                    <Checkbox
                                                                        checkbox
                                                                        name={'vte_hemodynamic_instability' + i}
                                                                        defaultChecked={input.vte_hemodynamic_instability[i] === 'Y' ? true : false}
                                                                        value='Y'
                                                                        onChange={(e, {
                                                                            name,
                                                                            value,
                                                                            checked
                                                                        }) => handleInputChange({
                                                                            target: {
                                                                                name,
                                                                                value,
                                                                                checked
                                                                            }
                                                                        })}
                                                                    />
                                                                </Table.Cell>
                                                            )}
                                                        </>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>3</Table.Cell>
                                                    <Table.Cell>Hemoglobin drop > 2 g/dl in under 12 hr</Table.Cell>
                                                    {ids.state == '0' ? <> {[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_hemoglobin_drop' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <> {[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_hemoglobin_drop' + i}
                                                                defaultChecked={input.vte_hemoglobin_drop[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>4</Table.Cell>
                                                    <Table.Cell>Ongoing Blood transfusion</Table.Cell>
                                                    {ids.state == '0' ? <> {[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_ongoing_blood_transfusion' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <> {[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_ongoing_blood_transfusion' + i}
                                                                defaultChecked={input.vte_ongoing_blood_transfusion[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>5</Table.Cell>
                                                    <Table.Cell>PT > 3 seconds above control</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_pt' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_pt' + i}
                                                                defaultChecked={input.vte_pt[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>6</Table.Cell>
                                                    <Table.Cell>{'Platelet count < 50,000 /mm3'}</Table.Cell>
                                                    {ids.state == '0' ? <> {[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_platelet_count' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <> {[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_platelet_count' + i}
                                                                defaultChecked={input.vte_platelet_count[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>7</Table.Cell>
                                                    <Table.Cell>Grade 4 or 5 solid organ injury (พิจารณาให้ delay
                                                        pharmacologic prophylaxis after 72 hrs)</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_grade' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_grade' + i}
                                                                defaultChecked={input.vte_grade[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell colSpan={'9'}>*หากมี<u>ข้อห้าม</u>ในการเร่ิมให้ยาละลายลิ่มเลือด
                                                        (ข้อ 1-6) ให้ใช้ Sequential Compressive Device (SCD)
                                                        และประเมินซ้ำใน 24 ชั่วโมง</Table.Cell>
                                                </Table.Row>
                                                <Table.Row active={true}>
                                                    <Table.Cell colSpan={'9'}>
                                                        <Checkbox
                                                            checkbox
                                                            label=' Traumatic Brain Injury'
                                                            name='vte_traumatic_brain_Injury'
                                                            checked={input.vte_traumatic_brain_Injury === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        /> &nbsp;&nbsp;&nbsp;
                                                        <Icon size={'big'} name='arrow circle right'/>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Checkbox
                                                            checkbox
                                                            label='Intracerebral Hemorrhage*'
                                                            name='vte_intracerebral_hemorrhage'
                                                            checked={input.vte_intracerebral_hemorrhage === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Checkbox
                                                            checkbox
                                                            label='No ICH **เริ่มให้ Pharmacologic prophylaxis ภายใน 72 ชั่วโมง'
                                                            name='vte_ICH'
                                                            checked={input.vte_ICH === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>1.</Table.Cell>
                                                    <Table.Cell>Progrssion of intracerebral hemorrhage on follow up
                                                        CT</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_progrssion' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_progrssion' + i}
                                                                defaultChecked={input.vte_progrssion[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>2.</Table.Cell>
                                                    <Table.Cell>Presented sign of active bleeding</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_presented' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day7.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_presented' + i}
                                                                defaultChecked={input.vte_presented[i] === 'Y' ? true : false}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell colSpan={'9'}>
                                                        *หากมี<u>ข้อห้าม</u>ในการเริ่มให้ยาละลายลิ่มเลือด (ข้อ 1-2)
                                                        ให้ใช้ Sequential Compressive Device (SCD) และประเมินซ้ำใน 24
                                                        ชั่วโมง<br/>
                                                        **พิจารณาให้ยาละลายลิ่มเลือดภายใน 24 ชั่วโมงเมื่อ CT stable
                                                    </Table.Cell>
                                                </Table.Row>
                                                <Table.Row active={true}>
                                                    <Table.Cell colSpan={'9'}>
                                                        <Checkbox
                                                            checkbox
                                                            label=' Spinal injury'
                                                            name='vte_spinal_injury'
                                                            checked={input.vte_spinal_injury === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />

                                                    </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell colSpan={'9'}>
                                                        <Checkbox
                                                            checkbox
                                                            label='No operation'
                                                            name='vte_no_operation'
                                                            checked={input.vte_no_operation === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Icon size={'big'}
                                                              name='arrow circle right'/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Start
                                                        Pharmacologic Prophylaxis
                                                    </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell colSpan={'9'}>
                                                        <Checkbox
                                                            checkbox
                                                            label='Plan operation within 24 hr '
                                                            name='vte_plan_operation_with24'
                                                            checked={input.vte_plan_operation_with24 === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Icon size={'big'}
                                                              name='arrow circle right'/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Start
                                                        Pharmacologic Prophylaxis after operation
                                                    </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell colSpan={'9'}>
                                                        <Checkbox
                                                            checkbox
                                                            label='Plan operation > 24 hr'
                                                            name='vte_plan_operation_over24'
                                                            checked={input.vte_plan_operation_over24 === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Icon size={'big'}
                                                              name='arrow circle right'/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Start
                                                        Pharmacologic Prophylaxis (stop 12 hr prior operation)
                                                    </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell colSpan={'9'}>
                                                        *** หากไม่สามารถให้ Pharmacological prophylaxis ภายใน 7 วัน
                                                        ให้ทําการตรวจ Duplex ultrasound both legs<br/><br/>
                                                        <Checkbox
                                                            checkbox
                                                            label='วันที่ Duplex US : '
                                                            name='vte_duplex_us'
                                                            checked={input.vte_duplex_us === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        /> &nbsp;&nbsp;&nbsp;
                                                        <Input type={'text'} style={{width: '300px'}}
                                                               name='vte_duplex_us_remark'
                                                               value={input.vte_duplex_us_remark}
                                                               onChange={(e) => handleValueChange(e)}
                                                        /> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;

                                                        <Checkbox
                                                            checkbox
                                                            label='ผล No DVT'
                                                            name='vte_dvt'
                                                            checked={input.vte_dvt === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        /> &nbsp;&nbsp;&nbsp;
                                                        <Checkbox
                                                            checkbox
                                                            label='Presented DVT in'
                                                            name='vte_presented_dvt'
                                                            checked={input.vte_presented_dvt === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        /> &nbsp;&nbsp;&nbsp;
                                                        <Input type={'text'} style={{width: '500px'}}
                                                               name='vte_presented_dvt_remark'
                                                               value={input.vte_presented_dvt_remark}
                                                               onChange={(e) => handleValueChange(e)}
                                                        /> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                                                    </Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                    </Form>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={15}>
                                <Segment color='teal' raised>
                                    <Header as='h3' dividing color='blue'>
                                        Part 3 : Assessment of signs and symptoms of DVT
                                    </Header>
                                    <Header as='h4' color='black'>
                                        จำนวนวันนอน &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;<Dropdown placeholder='days'
                                                                                                   search selection
                                                                                                   value={input.vte_sleep_part3}
                                                                                                   name={'vte_sleep_part3'}
                                                                                                   options={options14}
                                                                                                   onChange={(e, {value}) => setDay14({day: value})}/>
                                    </Header>
                                    <Form>
                                        <Table celled>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>#</Table.HeaderCell>
                                                    <Table.HeaderCell>อาการแสดงDVT</Table.HeaderCell>
                                                    <Table.HeaderCell>D1</Table.HeaderCell>
                                                    <Table.HeaderCell>D2</Table.HeaderCell>
                                                    <Table.HeaderCell>D3</Table.HeaderCell>
                                                    <Table.HeaderCell>D4</Table.HeaderCell>
                                                    <Table.HeaderCell>D5</Table.HeaderCell>
                                                    <Table.HeaderCell>D6</Table.HeaderCell>
                                                    <Table.HeaderCell>D7</Table.HeaderCell>
                                                    <Table.HeaderCell>D8</Table.HeaderCell>
                                                    <Table.HeaderCell>D9</Table.HeaderCell>
                                                    <Table.HeaderCell>D10</Table.HeaderCell>
                                                    <Table.HeaderCell>D11</Table.HeaderCell>
                                                    <Table.HeaderCell>D12</Table.HeaderCell>
                                                    <Table.HeaderCell>D13</Table.HeaderCell>
                                                    <Table.HeaderCell>D14</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                <Table.Row>
                                                    <Table.Cell>1</Table.Cell>
                                                    <Table.Cell>Throbbing or cramping pain in leg</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_throbbing_cramping' + i}

                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_throbbing_cramping' + i}
                                                            defaultChecked={input.vte_throbbing_cramping[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>2</Table.Cell>
                                                    <Table.Cell>Swelling in leg</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_swell' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_swell' + i}
                                                            defaultChecked={input.vte_swell[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>3</Table.Cell>
                                                    <Table.Cell>Warm skin around painful area</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_warm_skin' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_warm_skin' + i}
                                                            defaultChecked={input.vte_warm_skin[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>4</Table.Cell>
                                                    <Table.Cell>Red and darkened skin around the painful area</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_reddarkened' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_reddarkened' + i}
                                                            defaultChecked={input.vte_reddarkened[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row active={true}>
                                                    <Table.Cell>#</Table.Cell>
                                                    <Table.Cell>อาการแสดงPE</Table.Cell>
                                                    <Table.HeaderCell>D1</Table.HeaderCell>
                                                    <Table.HeaderCell>D2</Table.HeaderCell>
                                                    <Table.HeaderCell>D3</Table.HeaderCell>
                                                    <Table.HeaderCell>D4</Table.HeaderCell>
                                                    <Table.HeaderCell>D5</Table.HeaderCell>
                                                    <Table.HeaderCell>D6</Table.HeaderCell>
                                                    <Table.HeaderCell>D7</Table.HeaderCell>
                                                    <Table.HeaderCell>D8</Table.HeaderCell>
                                                    <Table.HeaderCell>D9</Table.HeaderCell>
                                                    <Table.HeaderCell>D10</Table.HeaderCell>
                                                    <Table.HeaderCell>D11</Table.HeaderCell>
                                                    <Table.HeaderCell>D12</Table.HeaderCell>
                                                    <Table.HeaderCell>D13</Table.HeaderCell>
                                                    <Table.HeaderCell>D14</Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>1</Table.Cell>
                                                    <Table.Cell>Dyspnea</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_dyspnea' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_dyspnea' + i}
                                                            defaultChecked={input.vte_dyspnea[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}

                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>2</Table.Cell>
                                                    <Table.Cell>Chest pain</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_chest_pain' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_chest_pain' + i}
                                                            defaultChecked={input.vte_chest_pain[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>3</Table.Cell>
                                                    <Table.Cell>Hemoptysis</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_hemoptysis' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_hemoptysis' + i}
                                                            defaultChecked={input.vte_hemoptysis[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>4</Table.Cell>
                                                    <Table.Cell>Syncope/Presyncope</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_syncope' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_syncope' + i}
                                                            defaultChecked={input.vte_syncope[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>5</Table.Cell>
                                                    <Table.Cell>Tachycardia</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_tachycardia' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_tachycardia' + i}
                                                            defaultChecked={input.vte_tachycardia[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>6</Table.Cell>
                                                    <Table.Cell>Tachypnea</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_tachypnea' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_tachypnea' + i}
                                                            defaultChecked={input.vte_tachypnea[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>7</Table.Cell>
                                                    <Table.Cell>Decrease BS</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_decrease' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_decrease' + i}
                                                            defaultChecked={input.vte_decrease[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>8</Table.Cell>
                                                    <Table.Cell>Jugular v. distension</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_jugular' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_jugular' + i}
                                                            defaultChecked={input.vte_jugular[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>9</Table.Cell>
                                                    <Table.Cell>Decrease O2 sat</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_decreaseO' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_decreaseO' + i}
                                                            defaultChecked={input.vte_decreaseO[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>10</Table.Cell>
                                                    <Table.Cell>S1Q3T3 on ECG</Table.Cell>
                                                    {ids.state == '0' ? <>{[...Array(day14.day)].map((x, i) =>
                                                        <Table.Cell>
                                                            <Checkbox
                                                                checkbox
                                                                name={'vte_sqt_ecg' + i}
                                                                value='Y'
                                                                onChange={(e, {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }) => handleInputChange({
                                                                    target: {
                                                                        name,
                                                                        value,
                                                                        checked
                                                                    }
                                                                })}
                                                            />
                                                        </Table.Cell>
                                                    )}</> : <>{[...Array(day14.day)].map((x, i) => <Table.Cell>
                                                        <Checkbox
                                                            checkbox
                                                            name={'vte_sqt_ecg' + i}
                                                            defaultChecked={input.vte_sqt_ecg[i] === 'Y' ? true : false}
                                                            value='Y'
                                                            onChange={(e, {name, value, checked}) => handleInputChange({
                                                                target: {
                                                                    name,
                                                                    value,
                                                                    checked
                                                                }
                                                            })}
                                                        />
                                                    </Table.Cell>)}</>}
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                        <Form.Button color='blue'
                                                     onClick={() => saveVte()}
                                        ><Icon name='plus'/> บันทึก แบบประเมินความเสี่ยง</Form.Button>
                                    </Form>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            </div>
        </>
    );
}

export default Vte;
